import React, { useEffect } from "react";
import { useLocation } from "react-router-dom";

import Hero from "../components/Hero";
import About from "../components/About";
import Services from "../components/Services";
import Features from "../components/Features";
import Testimonials from "../components/Testimonials";
import NewsletterSection from "../components/NewsletterSection";
import Contact from "../components/Contact";

function HomePage() {
  const { hash } = useLocation();

  useEffect(() => {
    if (!hash) {
      return undefined;
    }

    const frameId = window.requestAnimationFrame(() => {
      const target = document.getElementById(hash.slice(1));
      if (target) {
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      }
    });

    return () => window.cancelAnimationFrame(frameId);
  }, [hash]);

  return (
    <>
      <Hero />
      <About />
      <Services />
      <Features />
      <Testimonials />
      <NewsletterSection />
      <Contact />
    </>
  );
}

export default HomePage;